package ff.auth

data class Auth0Credentials(
    var accessToken: String? = null,
    var expiresIn: Int? = null,
    var tokenType: String? = null,
    var userInfo: Auth0UserInfo? = null,
)